import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import Account from './Account'
import MetaPages from './MetaPages';
import Youtube from './Youtube';

// const Product = lazy(() => import('./Product/Product'))
// const Products = lazy(() => import('./products/Products'))

const AccountConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'integration/account',
      element: <Account />,
    },
    {
      path: 'integration/meta-pages',
      element: <MetaPages />,
    },
    {
      path: 'integration/youtube',
      element: <Youtube />,
    },
    // {
    //   path: 'review link',
    //   element: <Product />,
    // },
  ],
}

export default AccountConfig